import { COUNTRY_CODES } from "$routes/_lib/constants";
import { useTerritoryCode } from "$routes/new/_lib/use-territory";
import { liberiaPhoneRegex } from "$routes/new/patient/_lib/sharedFormValidation";
import phone, { type PhoneResult } from "phone";

const invalidPhoneResult: PhoneResult = {
  isValid: false,
  phoneNumber: null,
  countryIso2: null,
  countryIso3: null,
  countryCode: null,
};

const isForeignInternationalNumber = (phoneNumber: string) =>
  phoneNumber.startsWith("+") && !phoneNumber.startsWith("+231");

const liberiaPhone = (phoneNumber: string): PhoneResult => {
  const nationalNumber = phoneNumber
    .replace(/\s/g, "")
    .match(liberiaPhoneRegex)?.[1];

  if (!nationalNumber) {
    return invalidPhoneResult;
  }

  return {
    isValid: true,
    phoneNumber: `+231${nationalNumber}`,
    countryIso2: COUNTRY_CODES.LIBERIA,
    countryIso3: "LBR",
    countryCode: "+231",
  };
};

export function usePhoneValidation(): (phoneNumber: string) => PhoneResult {
  const territoryCode = useTerritoryCode();

  return (phoneNumber: string) => {
    if (
      territoryCode === COUNTRY_CODES.LIBERIA &&
      !isForeignInternationalNumber(phoneNumber?.trim() ?? "")
    ) {
      return liberiaPhone(phoneNumber ?? "");
    }

    return phone(phoneNumber, {
      country: phoneNumber?.startsWith("+") ? null : territoryCode,
    });
  };
}
